/**
 * Common regex patterns used across the application
 */

export const regexEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Matches a bare website domain such as "example.com" or "sub.example.co.uk"
// (no protocol, path, or trailing slash).
export const regexDomain =
  /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

// Characters permitted in a user-entered file name (extension excluded).
// \u2013 and \u2014 are the en and em dashes, which clients routinely paste
// into document names.
export const regexFileName = /^[-\u2013\u2014\w^&'@{}[\],$=!#().%+~ ]+$/;
